<p-dialog
  styleClass="!border-line-default"
  [modal]="true"
  [visible]="visible"
  [dismissableMask]="true"
  (visibleChange)="_onVisibleChange($event)">
  <ng-template pTemplate="headless">
    <div
      class="bg-bg-surface-default relative flex h-88.75 w-80 flex-col items-center rounded-lg p-8 pt-26">
      <ic-coming-soon class="absolute -top-20 left-1/2 w-36 -translate-x-1/2" />
      <div class="flex grow flex-col gap-3">
        <h1 class="text-text-default text-center text-lg leading-6 font-bold">
          Fitur ini sedang dalam tahap pengembangan
        </h1>
        <p class="text-text-subtle text-center text-sm font-normal">
          Untuk memastikan performa yang optimal dan pengalaman pengguna yang baik. Harap bersabar,
          pembaruan akan segera tersedia!
        </p>
      </div>
      <app-button
        class="w-40"
        (click)="_hide()">
        Tutup
      </app-button>
    </div>
  </ng-template>
</p-dialog>
